<template>
    <div class="h-full w-full">
        <router-view />
    </div>
</template>
